import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { ToastProvider } from "./context/ToastContext";
import { DayLockProvider } from "./hooks/useDayLock";
import Layout from "./components/Layout";
import { Loader } from "./components/ui";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import Sales from "./pages/Sales";
import SaleDetail from "./pages/SaleDetail";
import Projects from "./pages/Projects";
import ProjectKhata from "./pages/ProjectKhata";
import Expenses from "./pages/Expenses";
import Vendors from "./pages/Vendors";
import VendorKhata from "./pages/VendorKhata";
import UdharVendors from "./pages/UdharVendors";
import VendorUdhar from "./pages/VendorUdhar";
import Statement from "./pages/Statement";
import Ledger from "./pages/Ledger";
import Logs from "./pages/Logs";
import Builders from "./pages/Builders";
import Banks from "./pages/Banks";

function Guard() {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="boot">
        <Loader label="Opening your books..." />
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return (
    <DayLockProvider>
      <Layout />
    </DayLockProvider>
  );
}

function AppRoutes() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route element={<Guard />}>
        <Route path="/" element={<Dashboard />} />
        <Route path="/sales" element={<Sales />} />
        <Route path="/sales/:id/statement" element={<Statement kind="sale" />} />
        <Route path="/sales/:id" element={<SaleDetail />} />
        <Route path="/projects" element={<Projects />} />
        <Route path="/projects/:id" element={<ProjectKhata />} />
        <Route path="/projects/:id/statement" element={<Statement kind="project" />} />
        <Route path="/expenses" element={<Expenses />} />
        <Route path="/expenses/:id/statement" element={<Statement kind="expense" />} />
        <Route path="/vendors" element={<Vendors />} />
        <Route path="/vendors/udhar" element={<UdharVendors />} />
        <Route path="/vendors/:id/udhar" element={<VendorUdhar />} />
        <Route path="/vendors/:id/statement" element={<Statement kind="vendor" />} />
        <Route path="/vendors/:id" element={<VendorKhata />} />
        <Route path="/ledger/statement" element={<Statement kind="ledger" />} />
        <Route path="/ledger/:id/statement" element={<Statement kind="ledgerDay" />} />
        <Route path="/ledger" element={<Ledger />} />
        <Route path="/banks" element={<Banks />} />
        <Route path="/logs" element={<Logs />} />
        <Route path="/builders" element={<Builders />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <ToastProvider>
          <AppRoutes />
        </ToastProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}
